const APP_VERSION = '1781107890955';
export default APP_VERSION;
